'use client';

import { useEffect, useState } from 'react';
import { ImageOff } from 'lucide-react';
import { useI18n } from '@/contexts/I18nContext';
import { cn } from '@/lib/utils/cn';

export function SafeGenerationImage({
  src,
  className,
  onMeasured,
}: {
  src: string;
  className?: string;
  /** Fired after the image's intrinsic dimensions are known. Used by the
   *  library grid to size its card to the picture's true aspect ratio. */
  onMeasured?: (width: number, height: number) => void;
}) {
  const { t } = useI18n();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (failed) {
    return (
      <div className="flex h-full w-full flex-col items-center justify-center bg-ink-950/5 p-4 text-center">
        <ImageOff className="h-8 w-8 text-ink-300" />
        <p className="mt-3 text-sm font-black text-ink-700">
          {t('studio.mediaUnavailable')}
        </p>
        <p className="mt-1 max-w-[13rem] text-xs leading-5 text-ink-400">
          {t('studio.mediaUnavailableHint')}
        </p>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt=""
      draggable={false}
      className={cn('h-full w-full object-cover', className)}
      onError={() => setFailed(true)}
      onLoad={(e) => {
        const img = e.currentTarget;
        if (onMeasured && img.naturalWidth && img.naturalHeight) {
          onMeasured(img.naturalWidth, img.naturalHeight);
        }
      }}
    />
  );
}
